import { Link, useMatch } from "react-router-dom";
import { observer } from "mobx-react-lite";

import { BOT_ROUTE, PARTY_MARKET_SECTION_PATH } from "@/app/constants/routes";
import { useGetPartyFromUrl } from "@/app/hooks";
import { getMarketSectionLink, MarketRoutes } from "@/shared/routing";
import { useMarketsState, usePartiesState } from "@/shared/stores/app-state";

import { useGetMarketDefaultPath } from "../../aside/ui/back-layer-button/hooks";

const useGetPartySectionTitle = () => {
	const { partiesMap } = usePartiesState();
	const partyUUID = useGetPartyFromUrl();

	if (!partyUUID) return "";

	return `party • ${partiesMap[partyUUID]}`;
};

const useGetBotSectionTitle = () => {
	const botRoute = useMatch(BOT_ROUTE);

	if (!botRoute) return "";

	const { botType, uuid } = botRoute.params;

	return `${botType} • ${uuid}`;
};

export const PartyCrumbTitle = () => {
	const title = useGetPartySectionTitle();
	return <span>{title}</span>;
};

export const BotCrumbTitle = () => {
	const title = useGetBotSectionTitle();
	return <span>{title}</span>;
};

export const AlgosCrumbTitle = () => {
	const marketRoute = useMatch(PARTY_MARKET_SECTION_PATH);

	if (
		!marketRoute ||
		!marketRoute.params ||
		!marketRoute.params.marketUUID ||
		!marketRoute.params.partyUUID
	)
		return "";

	const { marketUUID, partyUUID } = marketRoute.params;

	if (marketRoute.params["*"] === MarketRoutes.Algos) return "Algos";

	return (
		<Link to={getMarketSectionLink({ marketSection: "algos", marketUUID, partyUUID })}>Algos</Link>
	);
};

export const MarketCrumbTitle = observer(() => {
	const { getMarket } = useMarketsState();

	const marketRoute = useMatch(PARTY_MARKET_SECTION_PATH);
	const { partyUUID = "", marketUUID = "" } = marketRoute?.params || {};

	const marketsURL = useGetMarketDefaultPath();
	const currentMarket = getMarket(partyUUID, marketUUID);

	return <Link to={marketsURL}>{`market • ${currentMarket?.marketLabel || ""}`}</Link>;
});
